import React, { useEffect } from "react";
import * as S from "../styled";
import { passwordSchema as validationSchema } from "@/validation/register";
import { AbstractField } from "_c/form/Field";
import { useForm, FormContext } from "react-hook-form";
import PT from "prop-types";
import PassInput from "../../pass-input";
import { Button } from "_c/button";
import { analyticsAction } from "@/utils/analytics";

const RegisterFormPassword = (props) => {
  const methods = useForm({
    validationSchema,
    defaultValues: props.defaultValues,
  });
  const { handleSubmit } = methods;
  useEffect(() => {
    analyticsAction({
      category: "reg",
      action: "password_screen",
    });
  }, []);
  const onSubmit = async (form) => {
    analyticsAction({
      category: "login",
      action: "log_step_2",
    });
    await props.onSubmit(form);
  };
  return (
    <FormContext {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <S.InputSect>
          <AbstractField
            t={props.t}
            id="reg_pass"
            Component={PassInput}
            name="password"
            placeholder={props.t("login:pass")}
            aria-label={props.t("login:pass")}
          />
          <AbstractField
            t={props.t}
            id="reg_repeat_pass"
            Component={PassInput}
            name="repeat_password"
            placeholder={props.t("login:repeat_pass")}
            aria-label={props.t("login:repeat_pass")}
          />
        </S.InputSect>
        <Button
          css={`
            margin-right: 10px;
          `}
          small
          negative
          type="button"
          onClick={() => props.prevStep()}
        >
          {props.t("common:prev")}
        </Button>
        <S.SubmitButton
          disabled={props.submitting}
          greenish
          small
          type="submit"
        >
          {props.t("login:create_profile")}
        </S.SubmitButton>
      </form>
    </FormContext>
  );
};
RegisterFormPassword.propTypes = {
  defaultValues: PT.object.isRequired,
  submitting: PT.bool.isRequired,

  prevStep: PT.func.isRequired,
  t: PT.func.isRequired,
  onSubmit: PT.func.isRequired,
};
export default RegisterFormPassword;
